import React, { Fragment } from 'react';
import '../../assets/styles/dab.css'
import "bootstrap/dist/css/bootstrap.min.css";
import PropTypes from "prop-types";

interface IEditableDropdownProps {
	value: any;
	oldValue?: any;
	onChange?: any;
	onBlur?: any;
	onSelect?: any;
	objValue?: any;
	key?: any;
	suggestions: any;
	idValue: string;
	maxLength?: number;
	disable?: boolean;
}

interface IEditableDropdownState {
	modal: boolean;
	backdrop: string;
}

class EditableDropdownModal extends React.Component<IEditableDropdownProps>  {
	state = {
		// The active selection's index
		activeSuggestion: 0,
		// The suggestions that match the user's input
		filteredSuggestions: [],
		// Whether or not the suggestion list is shown
		showSuggestions: false,
		// What the user has entered
		userInput: ""
	};
	static propTypes = {
		suggestions: PropTypes.instanceOf(Array)
	};

	static defaultProps = {
		suggestions: []
	};

	constructor(props) {
		super(props);

		this.state = {
			// The active selection's index
			activeSuggestion: 0,
			// The suggestions that match the user's input
			filteredSuggestions: [],
			// Whether or not the suggestion list is shown
			showSuggestions: false,
			// What the user has entered
			userInput: this.props.value
		};
	}

	// Reference to the suggestion list, used to keep the active suggestion visible while navigating with the keyboard
	suggestionsListRef = React.createRef<HTMLUListElement>();

	componentDidUpdate(prevProps, prevState) {
		if (prevState.activeSuggestion !== this.state.activeSuggestion && this.suggestionsListRef.current) {
			const activeItem = this.suggestionsListRef.current.children[this.state.activeSuggestion] as HTMLElement;
			if (activeItem) {
				activeItem.scrollIntoView({ block: "nearest" });
			}
		}
		// Re-filter when suggestions arrive after the user has started typing (e.g. loaded by an API call)
		if (prevProps.suggestions !== this.props.suggestions && this.state.showSuggestions && this.state.userInput) {
			this.setState({ filteredSuggestions: this.filterSuggestions(this.props.suggestions, this.state.userInput) });
		}
	}

	// Filter our suggestions that don't contain the user's input
	filterSuggestions = (suggestions, userInput) => (suggestions || []).filter(
		suggestion => suggestion && suggestion.toLowerCase && suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
	);

	onChange = e => {
		const { suggestions } = this.props;
		const userInput = e.currentTarget.value;

		const filteredSuggestions = this.filterSuggestions(suggestions, userInput);

		this.setState({
			activeSuggestion: 0,
			filteredSuggestions,
			showSuggestions: true,
			userInput: e.currentTarget.value
		});
		if (this.props.onChange && this.props.onChange !== null) {

			if (this.props.objValue && this.props.objValue !== null) {
				this.props.onChange(e, this.props.objValue);
			}
			else {
				this.props.onChange(e);
			}
		}
	};

	onClick = e => {
		this.setState({
			activeSuggestion: 0,
			filteredSuggestions: [],
			showSuggestions: false,
			userInput: e.currentTarget.innerText
		});

		var event = { target: { name: this.props.idValue, value: e.currentTarget.innerText } };
		if (this.props.onChange && this.props.onChange !== null) {
			if (this.props.objValue && this.props.objValue !== null) {
				this.props.onChange(event, this.props.objValue);
			}
			else {
				this.props.onChange(event);
			}
		}
		this.handleSelect(event);
	};

	handleSelect = e => {
		if (this.props.onSelect && this.props.onSelect !== null) {
			if (this.props.objValue && this.props.objValue !== null) {
				this.props.onSelect(e, this.props.objValue);
			}
			else {
				this.props.onSelect(e);
			}
		}
	};

	onBlur = e => {
		if (this.state.showSuggestions) {
			this.setState({ showSuggestions: false });
		}
		if (this.props.onBlur && this.props.onBlur !== null) {

			if (this.props.objValue && this.props.objValue !== null) {
				this.props.onBlur(e, this.props.objValue);
			}
			else {
				this.props.onBlur(e);
			}
		}
	};

	onSuggestionMouseDown = e => {
		// Prevent the input from losing focus when a suggestion is clicked
		e.preventDefault();
	};

	onKeyDown = e => {
		const { activeSuggestion, filteredSuggestions, showSuggestions } = this.state;

		// User pressed the enter key
		if (e.keyCode === 13 && this.props.onSelect && !(showSuggestions && filteredSuggestions.length)) {
			// No suggestion to pick, keep the typed text as the selected value
			this.setState({ showSuggestions: false });
			this.handleSelect({ target: { name: this.props.idValue, value: this.state.userInput } });
		}
		else if (e.keyCode === 13) {
			this.setState({
				activeSuggestion: 0,
				showSuggestions: false,
				userInput: filteredSuggestions[activeSuggestion]
			});

			if (this.props.onChange && this.props.onChange !== null) {
				var event = { target: { name: this.props.idValue, value: filteredSuggestions[activeSuggestion] } };
				if (this.props.objValue && this.props.objValue !== null) {
					this.props.onChange(event, this.props.objValue);
				}
				else {
					this.props.onChange(event);
				}
			}
			this.handleSelect({ target: { name: this.props.idValue, value: filteredSuggestions[activeSuggestion] } });
		}
		// User pressed the up arrow
		else if (e.keyCode === 38) {
			if (activeSuggestion === 0) {
				return;
			}

			this.setState({ activeSuggestion: activeSuggestion - 1 });
		}
		// User pressed the down arrow
		else if (e.keyCode === 40) {
			if (activeSuggestion + 1 >= filteredSuggestions.length) {
				return;
			}

			this.setState({ activeSuggestion: activeSuggestion + 1 });
		}
	};

	render() {
		const {
			onChange,
			onClick,
			onKeyDown,
			state: {
				activeSuggestion,
				filteredSuggestions,
				showSuggestions,
				userInput
			}
		} = this;

		let suggestionsListComponent;

		if (showSuggestions && userInput) {
			if (filteredSuggestions.length) {
				suggestionsListComponent = (
					<ul className="suggestions" ref={this.suggestionsListRef}>
						{filteredSuggestions.map((suggestion, index) => {
							let className;

							// Flag the active suggestion with a class
							if (index === activeSuggestion) {
								className = "suggestion-active";
							}

							return (
								<li className={className} key={suggestion} onMouseDown={this.onSuggestionMouseDown} onClick={onClick}>
									{suggestion}
								</li>
							);
						})}
					</ul>
				);
			} else {
				suggestionsListComponent = (
					<div className="no-suggestions">
						<em>No suggestions, you're on your own!</em>
					</div>
				);
			}
		}

		return (
			<Fragment>
				<input
					className={["form-control"].join(" ")}
					type="text"
					name={this.props.idValue}
					id={this.props.idValue}
					onChange={onChange}
					onKeyDown={onKeyDown}
					onBlur={this.onBlur}
					value={userInput}
					autoComplete="off"
					required
					maxLength={this.props.maxLength}
					disabled={this.props.disable}
				/>
				{suggestionsListComponent}
			</Fragment>
		);
	}
}

export default EditableDropdownModal;